module.exports = __webpack_public_path__ + "img/jobmule_studi_minimi.a1e308fc.png";